module.exports = __webpack_public_path__ + "static/media/ss8_preview.8f19cafb.jpg";